import React, {useEffect, useState} from 'react';
import {WebView} from 'react-native-webview';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useNavigation} from '@react-navigation/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';
import analytics from '@react-native-firebase/analytics';

import {Loading} from '../../../components/Interface/Loadings/Loading';

import {FocusAwareStatusBar} from '../../../context/statusbar';

import {Container, Header, Content, HeaderButton, HeaderIcon} from './styles';

export function Chat() {
  const navigation = useNavigation();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    analytics().logEvent('tela_ajuda_chat');
  }, []);

  return (
    <Container>
      {isLoading && <Loading />}
      <FocusAwareStatusBar
        barStyle="light-content"
        backgroundColor={theme.colors.primary}
      />

      <Content>
        <WebView
          source={{
            uri: 'http://192.168.0.17:8080/?client_id=picpay&token=123@',
          }}
          hideKeyboardAccessoryView={true}
          onLoadEnd={() => setIsLoading(false)}
          showsVerticalScrollIndicator={false}
        />
      </Content>
    </Container>
  );
}
